import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-estatistica-projetado',
  templateUrl: './estatistica-projetado.component.html',
  styleUrls: ['./estatistica-projetado.component.css']
})
export class EstatisticaProjetadoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
